<template>
    <div>
        <h1 class="first-header heading-large"><i class="fas fa-comments mr-2"></i>All Messages</h1>
        <div class="card conversations--wrapper overflow-auto bg-olf-light-greyish-blue">
            <div v-if="conversationList.length < 1" class="text-center m-4">
                No conversation found
            </div>
            <div v-else >
                <a 
                    href="#" 
                    class="conversations--action d-flex justify-content-between border-bottom text-decoration-none" 
                    :class="{active: conversationId == conversation._id}"
                    data-toggle="modal" data-target="#myConversation"
                    v-for="(conversation,key) in conversationList" @click="selectConversationMessage(key, conversation._id)" :key="key"
                >
                    <div class="d-flex justify-content-start">
                        <span class="conversations--image m-3 position-relative" v-if="!conversation.otherParty.img">
                            <i class="fas fa-user fa-lg" :class="{'notification': notificationList.find(n => n.viewed === null && n.type_id === 'MESSAGE' && n.group_id === conversation._id)}"></i>
                        </span>
                        <span class="conversations--image m-3 position-relative" v-else-if="conversation.img!=='default' ">
                            <img :src="`assets/${conversation.img}.jpg`" alt="user image" class="profile-image">
                        </span>
                        <div class="conversations--info d-flex flex-column justify-content-center text-tertiary">
                            <h5>{{conversation.otherParty.firstName}} {{conversation.otherParty.lastName}}</h5>
                            <span class="text-truncate" style="max-width: 145px;" v-if="conversation.messages.length > 0">
                                {{conversation.messages[conversation.messages.length - 1].message}}
                            </span>
                        </div>
                    </div>

                    <span v-if= "conversation.unread > 0" class="conversations--notification">{{conversation.unread}}</span>
                    <span v-else class="d-flex align-items-center mr-3"><i class="fas fa-caret-right text-tertiary"></i></span>
                </a>   
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StartConversation from './StartConversation.vue'
export default {
    components:{
        StartConversation
    },
    data:function(){
        return {
            newConversation: false,
        }
    },
    methods:{
        ...mapActions('conversation', ['selectConversation', 'loadConversation', 'updateGenericConversationsList',
            'getGenericConversationsList']),
        ...mapActions('notifications', ['updateNotification']),
        selectConversationMessage: function(conversationIndex, conversationId){
            this.selectConversation(conversationIndex)
            this.loadConversation(conversationId)
            if(this.notificationList.find(notification => notification.group_id === conversationId && notification.viewed === null)) // Ensures only unviewed notifications trigger an update
                this.updateNotification(conversationId); // Calls Action that Updates associated Message Notification
        },
        startConversation(){
            this._data.newConversation=true;
        },
        clearMessages: function(){
            this.selectConversation(-1)
            this.updateGenericConversationsList([])
        }
    },
    created: async function(){
        this.clearMessages()
        this.getGenericConversationsList()
    },
    computed:{
        ...mapState('conversation',['conversationData', 'conversationId', 'genericConversations']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('notifications', ['notificationList']),
        conversationList: {
            get: function(){
                let conversations = []

                if (this.genericConversations){
                    /* Send conversation most recently created/with most recent message to the top */
                    conversations = this.genericConversations.sort((a, b) => {
                        const dateA = a.messages.length > 0 ? new Date(a.messages[a.messages.length - 1].sent) : new Date(a.created)
                        const dateB = b.messages.length > 0 ? new Date(b.messages[b.messages.length - 1].sent) : new Date(b.created)

                        return dateB - dateA
                    })
                }

                return conversations;
            }
        }
    },
    beforeDestroy(){
        this.clearMessages()
    }
}
</script>


<style lang="scss" scoped>
@import "@/assets/scss/components/_conversations.scss";

</style>    